import React from 'react';
import { X, User } from 'lucide-react';
import Spinner from './Spinner';

const AbsentDetailModal = ({ isOpen, onClose, startDate, endDate, data, isLoading }) => {
  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} />
      
      <div className="relative bg-white w-full max-w-md rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-rose-50/50">
          <div>
            <h3 className="text-lg font-bold text-rose-800 flex items-center gap-2">
              <span className="w-2 h-2 bg-rose-500 rounded-full animate-pulse" />
              미출근 상세 내역
            </h3>
            <p className="text-xs text-rose-500 mt-0.5">{startDate === endDate ? startDate : `${startDate} ~ ${endDate}`}</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white rounded-full text-slate-400"><X size={20} /></button>
        </div>

        <div className="max-h-[60vh] overflow-y-auto p-4">
          {isLoading ? (
            <Spinner/>
        ) : data.length > 0 ? (
            <div className="space-y-3">
            {data.map((item, idx) => (
                <div key={idx} className="flex items-center justify-between p-4 rounded-2xl bg-slate-50 border border-slate-100">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm text-rose-400">
                      <User size={20} />
                    </div>
                    <div>
                    <div className="font-bold text-slate-800">{item.name}</div>
                    <div className="text-xs text-slate-500">{item.team}</div>
                    </div>
                </div>
                <div className="text-right">
                    {/* 🚀 변경된 부분: 기록 없음 -> 날짜 표시 */}
                    <div className="text-[10px] text-slate-400 font-medium">미출근 일자</div>
                    <div className="px-2 py-1 rounded-md bg-rose-100 text-rose-700 text-xs font-bold">
                    {formatDate(item.target_date)}
                    </div>
                </div>
                </div>
            ))}
            </div>
        ) : (
            <div className="py-20 text-center text-slate-400">미출근 내역이 없습니다.</div>
        )}
        </div>
        <div className="p-4 bg-slate-50 border-t border-slate-100">
          <button onClick={onClose} className="w-full py-3 bg-white border border-slate-200 rounded-xl font-bold text-slate-600">닫기</button>
        </div>
      </div>
    </div>
  );
};

export default AbsentDetailModal;